var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"title":"预览","width":"large","visible":_vm.visible,"dialog-style":{ top: '0', bottom: '0' },"body-style":{padding: '15px', minHeight: '300px', background: '#eee'},"footer":null},on:{"cancel":function($event){_vm.visible=false}}},[_c('PreviewR',{ref:"previewR",attrs:{"params":_vm.params}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-483a1aff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/design/PopPreview.vue
// module id = null
// module chunks = 